import { Libraries } from '@react-google-maps/api'

export const libraries: Libraries = ['places']
